import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { AchievementCardModalPage } from './achievement-card-modal';

@NgModule({
  declarations: [
    AchievementCardModalPage,
  ],
  imports: [
    RouterModule,
    CommonModule,
    IonicModule.forRoot(),
  ],
})
export class AchievementCardModalPageModule {}
